import { render, staticRenderFns } from "./LeadOverDueAppointment.vue?vue&type=template&id=2ca46ed1&"
import script from "./LeadOverDueAppointment.vue?vue&type=script&lang=js&"
export * from "./LeadOverDueAppointment.vue?vue&type=script&lang=js&"
import style0 from "./LeadOverDueAppointment.vue?vue&type=style&index=0&id=2ca46ed1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports